export const assertNever = (n: never) => n;

export const tryParseJSON = (jsonString: string): any => {
    try {
        return JSON.parse(jsonString);
    } catch {
        return null;
    }
};

const emailRegex = /^\S+@\S+\.\S+$/;

export const isEmail = (value: string) => {
    return emailRegex.test(value);
};

export const isEmailList = (value: string) => {
    if (!value) return false;
    return value.split(/\s*,\s*/).every(v => emailRegex.test(v));
};

const dataMarkerRegex = /^[a-z0-9.]+$/i;

export const isDataMarker = (value: string) => {
    if (!value) return false;
    return dataMarkerRegex.test(value);
};

export const preventDefault = (fn: () => void) => (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    e.preventDefault();
    fn();
};

const postcodeRegex = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} ?[0-9][A-Z]{2}$/i;
export const isPostcodeValid = (value: string) => postcodeRegex.test(value);

export const isPlainObject = (value: unknown) => value?.constructor === Object;

export const joinWithOr = (array: string[]) => {
    if (array.length === 0) {
        return "";
    }

    if (array.length === 1) {
        return array[0];
    }

    return array.slice(0, -1).join(", ") + " or " + array.at(-1);
};

export const unicodeBase64Decode = (encoded: string) => {
    const binary = window.atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return String.fromCharCode(...new Uint16Array(bytes.buffer));
};

export const unicodeBase64Encode = (input: string) => {
    const codeUnits = new Uint16Array(input.length);
    for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = input.charCodeAt(i);
    }

    return btoa(String.fromCharCode(...new Uint8Array(codeUnits.buffer)));
};

export const objectsAreTheSame = (array1: object | [], array2: object | []): boolean => {
    return JSON.stringify(array1) === JSON.stringify(array2);
};
